import * as React from "react";
import { Divider } from "antd";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

interface Props {}
export const AddonAzureAcr: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.azureACR.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | Azure Container Registry (ACR)
      </Divider>
      <div id={`addon-azureACR`} style={{ scrollMarginTop: 200 }}>
        <CpFormItem>
          <CpLabel name={"addons.azureACR.clientId"}>Client ID</CpLabel>
          <CpInput name={"addons.azureACR.clientId"} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={"addons.azureACR.clientId"} />
        </CpFormItem>
      </div>
    </>
  );
};
